var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedinIcon = function SvgLinkedinIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#2867B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5491 21.0787V12.9749H8.85785V21.0787H11.5493H11.5491ZM10.204 11.8686C11.1423 11.8686 11.7264 11.2463 11.7264 10.4687C11.7089 9.67327 11.1423 9.06836 10.2219 9.06836C9.30079 9.06836 8.69922 9.67327 8.69922 10.4686C8.69922 11.2463 9.28315 11.8686 10.1864 11.8686H10.2038L10.204 11.8686ZM13.0387 21.0787H15.7297V16.5537C15.7297 16.3118 15.7472 16.0693 15.8183 15.8965C16.0128 15.4124 16.4556 14.9113 17.1992 14.9113C18.1728 14.9113 18.5624 15.6543 18.5624 16.7439V21.0787H21.2534V16.4322C21.2534 13.9432 19.9259 12.7849 18.1553 12.7849C16.7037 12.7849 16.0662 13.597 15.712 14.15H15.7299V12.9752H13.0388C13.0739 13.7354 13.0386 21.079 13.0386 21.079L13.0387 21.0787Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Linkedin-icon.b353ab5e.svg";
export { ForwardRef as ReactComponent };